import { TAssetInvestmentDetailsSchema } from '@brickwise/asset-validation/dist/asset/investmentData';
import { useFormikContext } from 'formik';
import { FC } from 'react';
import { DefaultSlider } from 'src/components/mui-overrides/Slider';

interface Props {
  disabled?: boolean;
}

export const MaxSubscriptionAmountSlider: FC<Props> = ({ disabled }) => {
  const formik = useFormikContext<TAssetInvestmentDetailsSchema>();

  return (
    <DefaultSlider
      disabled={disabled}
      min={1}
      value={formik.values?.investmentDetails?.maxSubscriptionAmount || 0}
      onChange={(event: Event, value: number | number[]) => {
        formik.setFieldValue('investmentDetails.maxSubscriptionAmount', value as number);
      }}
    />
  );
};
